import { useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getVisitorId() {
  let id = localStorage.getItem("va_vid");
  if (!id) {
    id = Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem("va_vid", id);
  }
  return id;
}

export default function PageTracker() {
  useEffect(() => {
    const visitor_id = getVisitorId();
    const page = window.location.pathname + window.location.hash;
    axios.post(`${API}/pageview`, {
      page,
      visitor_id,
      referrer: document.referrer,
    }).catch(() => {});

    // Track hash changes (SPA navigation)
    const handleHash = () => {
      axios.post(`${API}/pageview`, {
        page: window.location.pathname + window.location.hash,
        visitor_id,
        referrer: "",
      }).catch(() => {});
    };
    window.addEventListener("hashchange", handleHash);
    return () => window.removeEventListener("hashchange", handleHash);
  }, []);

  return null;
}
